export default __webpack_public_path__ + "static/media/2 icon (1).b4d27b30.jpg";